import { render, staticRenderFns } from "./PlanOrFee.vue?vue&type=template&id=7473d912&scoped=true"
import script from "./PlanOrFee.vue?vue&type=script&lang=js"
export * from "./PlanOrFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7473d912",
  null
  
)

export default component.exports